<div class="features">
  <h1 class="ui-heading-1-bold features-title">{{ section() }}</h1>

  <ul class="features-content">
    @for (f of features(); track $index) {
      <li class="feature-item">
        <h2 class="ui-heading-3">{{ f.name }}</h2>
        <p class="ui-body-l-bold">{{ f.benefit }}</p>
        <p class="ui-body-l">{{ f.description }}</p>
      </li>
    }
  </ul>
</div>
<rds-divider class="divider"></rds-divider>
